import React from "react"
import AttributionCookie from "src/utils/AttributionCookie"

const FbclidCookie = () => <AttributionCookie name="fbclid" />

export default FbclidCookie
